import Swal from "sweetalert2";
import { Workout } from "../../application/domain/workout";
import { CreateWorkoutUseCase } from "../../application/usecases/create-workout.usecase";
import { DeleteWorkoutUseCase } from "../../application/usecases/delete-workout.usecase";
import { CreateWorkoutProps } from "./interfaces/create-workout.interface";
import { DeleteWorkoutProps } from "./interfaces/delete-workout.interface";
import { ListWorkoutsUseCase } from "../../application/usecases/list-workouts.usecase";
import { ListWorkoutsProps } from "./interfaces/list-workouts.interface";
import { urlsPages } from "../../../../common/urls/urls-pages";
import { ResolveDrillCodeUseCase } from "../../../drills/application/usecases/actions/resolve-drill-code.usecase";
import { DrillCode } from "../../../drills/application/domain/drill-code";


export class WorkoutController {
    static async create(ui: CreateWorkoutProps): Promise<void> {
        try {
            if (!ui.name || !ui.drillId) {
                Swal.fire({
                    title: "Erro",
                    text: "Por favor, digite o nome do treino",
                    icon: "error",
                });
                return;
            }
            const workout = new Workout();
            workout.drillId = ui.drillId;
            workout.name = ui.name;
            ui.setLoad(true);
            const workoutCreated = await CreateWorkoutUseCase.execute(workout);
            ui.setLoad(false);
            if (workoutCreated) {
                const drillCode = await ResolveDrillCodeUseCase.execute(ui.drillId);
                const page = drillCode === DrillCode.ARROW_RIGHT_LEFT ? urlsPages.connection : urlsPages.actions;
                window.location.href = page.replace(":workoutId", workoutCreated.id);
            }
        } catch (error) {
            ui.setLoad(false);
            this.showError("Erro ao criar treino");
        }
    }

    static async listWorkouts(ui: ListWorkoutsProps): Promise<void> {
        try {
            ui.setLoad(true);
            const output = await ListWorkoutsUseCase.execute(ui.drillId ?? "");
            ui.setWorkouts(output.workouts);
            ui.setDrillName(output.drill);
            ui.setLoad(false);
        } catch (error) {
            ui.setLoad(false);
            this.showError("Erro ao listar treinos");
        }
    }

    static async deleteWorkout(ui: DeleteWorkoutProps): Promise<void> {
        try {
            ui.setLoad(true);
            await DeleteWorkoutUseCase.execute(ui.workoutId);
            ui.setWorkouts((prev) => prev.filter((w) => w.id !== ui.workoutId));
            ui.setLoad(false);
        } catch (error) {
            ui.setLoad(false);
            this.showError("Erro ao excluir treino");
        }
    }

    private static showError(msg: string) {
        Swal.fire({
            title: "Erro",
            text: msg,
            icon: "error",
        });
    }
}